import "./TableCategorie.css";
import React from "react";
import Table from 'react-bootstrap/Table';

function template() {
  return (
    <Table striped hover responsive className='container-fluid ' id="tableCategorie">
    <thead>
      <tr>
        <th>ID</th>
        <th>CATEGORIE</th>
        <th>DATE CREATION</th>
        <th>DATE MODIFICATION</th>
        <th>STATUS</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1</td>
        <td>workshop</td>
        <td>cours</td>
        <td>compagny</td>
        <td>@mdo</td>
      </tr>
      <tr>
        <td>2</td>
        <td>Jacob</td>
        <td>Thornton</td>
        <td>@fat</td>
        <td>@fat</td>
      </tr>
      <tr>
        <td>3</td>
        <td colSpan={2}>Larry the Bird</td>
        <td>@twitter</td>
        <td>@fat</td>
      </tr>
      <tr>
        <td>1</td>
        <td>Mark</td>
        <td>Otto</td>
        <td>@mdo</td>
        <td>@fat</td>
      </tr>
      <tr>
        <td>2</td>
        <td>Jacob</td>
        <td>Thornton</td>
        <td>@fat</td>
        <td>@fat</td>
      </tr>
      <tr>
        <td>3</td>
        <td colSpan={2}>Larry the Bird</td>
        <td>@twitter</td>
        <td>@fat</td>
      </tr>
    </tbody>
  </Table>
  );
};

export default template;
